(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ReporteEvaluativoUAEVController', ReporteEvaluativoUAEVController);

    ReporteEvaluativoUAEVController.$inject = ['$scope', '$state', '$stateParams','ReporteEvaluativoUAEVService', 'ReporteEvaluativoUAEVRegenerarService','ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'LoginService','entity'
    	];

    function ReporteEvaluativoUAEVController ($scope, $state, $stateParams,ReporteEvaluativoUAEVService, ReporteEvaluativoUAEVRegenerarService,ParseLinks, AlertService, pagingParams, paginationConstants,LoginService,entity
    		) {
        var vm = this;
        vm.reporte=entity.reporte;
        vm.wrapper=entity;
        vm.tipo=entity.tipo;
        vm.round=round;
        vm.save=save;
        
        vm.print=print;
        
        function round(valor){
        	return Math.round(valor);
        }
        
        function print(){
        	window.print();
        }
        
        function save(){
        	 vm.isSaving = true;
        	 if(vm.wrapper.regenerar){
        		 ReporteEvaluativoUAEVRegenerarService.update(vm.wrapper, onSaveSuccess, onSaveError).
               	 $promise.then(function(result){
            		 vm.wrapper.reporte=result;
            	 });
        	 }else{
        		 if (vm.wrapper.reporte.id !== null) {
                	 ReporteEvaluativoUAEVService.update(vm.wrapper, onSaveSuccess, onSaveError).
                   	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 } else {
                	 ReporteEvaluativoUAEVService.save(vm.wrapper, onSaveSuccess, onSaveError).
                	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 }
        	 }
             
        }
        function onSaveSuccess (result) {
            $scope.$emit('sideApp:reporte', result);
            vm.isSaving = false;

//            if(vm.wrapper.regenerar){
//            	$state.go('volvergenerarReporteUAEV', null, { reload: true });
//            }else{
//            console.log($stateParams);
            	if(vm.wrapper.tipoUser==1){
            		 $state.go('generarReporteUAEV', 
            			{
            			 	idA: $stateParams.idA,
	             			idP: $stateParams.idP,
	             			idAnio: $stateParams.idAnio,
	             			idIndice: $stateParams.idIndice,
	             			ic: $stateParams.ic,
	                        iic: $stateParams.iic,
	             			tipoEvaluacion: $stateParams.tipoEvaluacion,
	             			idDependencia: $stateParams.idDependencia,
	             			nivell: $stateParams.nivell,
	             			modeloo: $stateParams.modeloo
            			} 
            				 
            		 ,{ reload: true });
            	}else{
            		if(vm.wrapper.tipoUser==2){
                        $state.go('revisionReporteUAEV', null, { reload: true });
                    }
            	}
//            }
        }
        

        function onSaveError () {
            vm.isSaving = false;
        }
        
        Highcharts.setOptions({
            chart: {
                backgroundColor: {
                    linearGradient: [0, 0, 500, 500],
                    stops: [
                        [0, 'rgb(255, 255, 255)'],
                        [1, 'rgb(255, 255, 255)']
                        ]
                },
                borderWidth: 2,
                plotBackgroundColor: 'rgba(255, 255, 255, .9)',
                plotShadow: true,
                plotBorderWidth: 1
            }
        });
        
        var chart1 = new Highcharts.Chart({
            chart: {
                renderTo: 'iteraccion',
    			type: 'bar'
            },
            title: {
                text: 'Relación Profesor - Estudiante'
            },
            xAxis: {
            	categories: 
            	[
            		'Muestra respeto en sus mensajes y comentarios',
            		'Promueve las reglas de la comunicación virtual (etiquetas)',
            		'Orienta al estudiantado para identificar sus necesidades o recursos para aprender de manera independiente',
            		'Promueve la ética en la asignatura que imparte',
            		'Utiliza diferentes herramientas institucionales de comunicación para mantener contacto'
            	],
                type: 'integer'
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: 
            [
	            {
	                name: 'Estudiantes',
	                data: 
	                	[
		                	Math.round(vm.reporte.respetoMensajesComs_e),
		                	Math.round(vm.reporte.promueveReglasComunicacionV_e), 
		                	Math.round(vm.reporte.orientaEstuIdenNec_e),
		                	Math.round(vm.reporte.promEtiAsigImp_e),
		                	Math.round(vm.reporte.utiDiferentesHerramientas_e)
	                	],
	               	color: '#002e5f'
	            }
            ]
        });

        var chart2 = new Highcharts.Chart({
            chart: {
                renderTo: 'estrategias',
    			type: 'bar'
            },
            title: {
                text: ''
            },
            xAxis: {
            	categories: [
            		'Sugiere actividades complementarias para reforzar el desarrollo de las competencias',
            		'Brinda seguimiento a las dudas o comentarios en el tiempo establecido',
            		'Utiliza actividades de aprendizaje que promueven el análisis de los temas tratados',
            		'Utiliza actividades donde el estudiante integra los conocimientos previos y los nuevos',
            		'Utiliza actividades que promueven el interés hacia el aprendizaje de la asignatura'
            		],
                type: 'integer'
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: [{
                name: 'Estudiantes',
                data: [Math.round(vm.reporte.sugiereActsComplem_e),
                		Math.round(vm.reporte.brindaSeguiDudas_e), 
                		Math.round(vm.reporte.utiActsAprendizaje_e),
                		Math.round(vm.reporte.utiActsIntegraConocimientos_e),
                		Math.round(vm.reporte.utiActsPromuInt_e)],
               	color: '#002e5f'
            }, {
                name: 'Profesor (a)',
                data: [Math.round(vm.reporte.sugieroActsComples_p), 
                	Math.round(vm.reporte.brindoSeguimientoDudas_p), 
                	Math.round(vm.reporte.utiActsAprenPromuevenAnalisis_p),
                	Math.round(vm.reporte.utiActsEstuInteConoci_p),
                	Math.round(vm.reporte.utiActsPromuInteApre_p)],
                color: '#ffb60f'
            }]
        });
        var chart3 = new Highcharts.Chart({
            chart: {
                renderTo: 'materias',
    			type: 'bar'
            },
            title: {
                text: ''
            },
            xAxis: {
            	categories: 
            	[
            		'Promueve el uso de diferentes herramientas tecnológicas, para el desarrollo de la asignatura',
            		'Utiliza diferentes materiales o recursos para orientar el aprendizaje'
            	],
                type: 'integer'
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: [{
                name: 'Estudiantes',
                data: 
                [
                	Math.round(vm.reporte.promuUsoDifHerrTecno_e),
                	Math.round(vm.reporte.utiDifMateriales_e)
                ],
               	color: '#002e5f'
            }, {
                name: 'Profesor (a)',
                data: [Math.round(vm.reporte.promuDifsHerrTecno_p), 
                	Math.round(vm.reporte.utiDifMateOriAprendizaje_p)],
                color: '#ffb60f'
            }]
        });
        var chart4 = new Highcharts.Chart({
            chart: {
                renderTo: 'evaluacion',
    			type: 'bar'
            },
            title: {
                text: ''
            },
            xAxis: {
            	categories: 
            		[
            			'Comunica el puntaje de cada una de las actividades de aprendizaje',
            			'Informa la puntuación obtenida en cada una de las actividades',
            			'Procura que las actividades se relacionen con lo visto en la asignatura',
            			'Retroalimenta el progreso académico para identificar fortalezas y debilidades',
            			'Retroalimenta las actividades utilizando los criterios de evaluación establecidos'
            		],
                type: 'integer'
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: [{
                name: 'Estudiantes',
                data: [
	                	Math.round(vm.reporte.comunicaPuntajeActs_e),
	                	Math.round(vm.reporte.infoPuntuacionObtenida_e), 
	                	Math.round(vm.reporte.procActsRelacionenVisto_e),
	                	Math.round(vm.reporte.retroaliProgrAcademico_e), 
	                	Math.round(vm.reporte.retroaliActsCriterios_e)
                	],
               	color: '#002e5f'
            }, {
                name: 'Profesor (a)',
                data: 
                	[
	                	Math.round(vm.reporte.comuPuntajeActsAprene_p), 
	                	Math.round(vm.reporte.infoPuntObtea_p), 
	                	Math.round(vm.reporte.procuraActsRelacionen_p),
	                	Math.round(vm.reporte.retroaliProgrAcade_p), 
	                	Math.round(vm.reporte.retroaliActsUtiCriterios_p)
                	],
                color: '#ffb60f'
            }]
        });
 
    }
})();
